var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M18,38.8c1.4,1.3,109.3,70.3,110,70.3c0.6,0,108.6-68.9,110-70.3c0.3-0.3-47.4-0.5-110-0.5C65.3,38.3,17.7,38.6,18,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M10,137.1v80.5h118h118v-80.5c0-44.3-0.1-80.5-0.3-80.5s-20.4,12.9-45,28.7c-24.5,15.8-50.9,32.6-58.4,37.5c-8.4,5.4-14.1,8.7-14.7,8.5c-0.5-0.1-27.1-17-58.9-37.5C36.7,73.4,10.5,56.6,10.3,56.6C10.1,56.6,10,92.8,10,137.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.f1b91d13a1d7fd12959306a094556edc.svg";
export { ForwardRef as ReactComponent };